import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";

import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import ViewSection from "./ViewSection/ViewSection";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class AddClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        className: "",
        faculty: "",
        group: "",
        section: [],
        subjects: [],
      },
      subjectData: {
        name: "",
      },
      sectionData: {
        name: "",
      },
      classError: "",
      subjectError: "",
      sectionError: "",
      subData: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getSubjects();
    if (this.props.editStatus) {
      this.getClass(this.props.levelId);
    }
  }

  getSubjects = async () => {
    try {
      const response = await Axios.get(`${url}/api/subjects`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.subjects.length !== 0) {
        this.setState({
          subData: response.data.subjects,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getSubjects();
      }
    }
  };

  getClass = async (classId) => {
    try {
      const response = await Axios.get(`${url}/api/schoolclass/${classId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.singleClass.length !== 0) {
        this.setState({
          data: {
            className: response.data.singleClass.className,
            faculty: response.data.singleClass.faculty
              ? response.data.singleClass.faculty
              : "",
            group: response.data.singleClass.group
              ? response.data.singleClass.group
              : "",
            section: response.data.singleClass.section,
            subjects: response.data.singleClass.subjects,
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getClass(classId);
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubjectChange = (e) => {
    this.setState({
      subjectData: {
        ...this.state.subjectData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSectionChange = (e) => {
    this.setState({
      sectionData: {
        ...this.state.sectionData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleEdit = (editIndex, editData) => {
    let newArray = this.state.data.section.map((data, index) =>
      index === editIndex ? editData : data
    );
    this.setState({ data: { ...this.state.data, section: newArray } });
  };

  handleDelete = (index) => {
    const toDel = this.state.data.section[index];
    const newArray = this.state.data.section.filter((data) => {
      return data.name.toLowerCase().indexOf(toDel.name.toLowerCase());
    });
    this.setState({
      data: { ...this.state.data, section: newArray },
    });
  };
  handleDeleteSubject = (index) => {
    const toDel = this.state.data.subjects[index];
    const newArray = this.state.data.subjects.filter((data) => {
      return data.name.toLowerCase().indexOf(toDel.name.toLowerCase());
    });
    this.setState({
      data: { ...this.state.data, subjects: newArray },
    });
  };

  handleSectionSubmit = (e) => {
    let sectionError = false;
    if (
      this.state.data.section.some(
        (data) => data.name === this.state.sectionData.name
      )
    ) {
      sectionError = "This section already existed";
    } else if (this.state.sectionData.name === "") {
      sectionError = "please enter section name";
    } else {
      sectionError = false;
    }
    if (sectionError) {
      this.setState({
        sectionError,
      });
    }
    if (sectionError === false) {
      this.setState({
        data: {
          ...this.state.data,
          section: [...this.state.data.section, this.state.sectionData],
        },
        sectionError: "",
      });
    }
  };

  handleSubjectSubmit = (e) => {
    let subjectError = false;
    if (
      this.state.data.subjects.some(
        (data) => data.name === this.state.subjectData.name
      )
    ) {
      subjectError = "Subject already added";
    } else if (this.state.subjectData.name === "") {
      subjectError = "please enter section name";
    } else {
      subjectError = false;
    }
    if (subjectError) {
      this.setState({
        subjectError,
      });
    }
    if (subjectError === false) {
      this.setState({
        data: {
          ...this.state.data,
          subjects: [...this.state.data.subjects, this.state.subjectData],
        },
        subjectError: "",
      });
    }
  };

  showAdd = () => {
    return (
      <IconButton
        aria-label="Add"
        onClick={this.handleSectionSubmit}
        style={{ cursor: "pointer" }}
      >
        <AddCircleIcon />
      </IconButton>
    );
  };

  setValue = (name, value) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: value.todos,
      },
    });
  };

  checkError = (studentClass) => {
    let classError = studentClass ? studentClass : "";
    let sectionError = "";
    let subjectError = "";

    if (this.state.data.section.length === 0) {
      sectionError =
        "Enter at least one section. If there is no section enter A by default";
    }
    if (this.state.data.subjects.length === 0) {
      subjectError = "Enter at least one subjects.";
    }

    if (classError || sectionError || subjectError) {
      this.setState({
        classError,
        sectionError,
        subjectError,
      });
      return true;
    } else {
      this.setState({
        classError: "",
        sectionError: "",
        subjectError: "",
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = { ...data };
    if (!data.faculty) {
      delete changedData.faculty;
    }

    if (!data.group) {
      delete changedData.group;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        if (this.props.editStatus) {
          let changedData = this.filterData(this.state.data);
          let data = { ...changedData };
          const editResponse = await Axios.put(
            `${url}/api/schoolclass/${this.props.levelId}`,
            data,
            { headers: { Authorization: `Bearer ${this.props.adminToken}` } }
          );
          if (editResponse.data.message === "class edited successfully") {
            this.props.history.push(`/administration/class`);
          }
        } else {
          let changedData = this.filterData(this.state.data);
          let data = { ...changedData };
          const response = await Axios.post(`${url}/api/schoolclass`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "class added successfully") {
            this.props.history.push(`/administration/class`);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message === "Class with given data already exists"
        ) {
          console.clear();
          this.checkError("Class already stored");
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.levelId ? (
            <PageTitle title="Edit Class" />
          ) : (
            <PageTitle title="Add Class Detail" />
          )}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
              <Paper className={classes.paper}>
                <form onSubmit={this.handleSubmit}>
                  <div>
                    <TextField
                      name="className"
                      type="text"
                      label="Class Name"
                      required
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      error={this.state.classError ? true : false}
                      helperText={
                        this.state.classError
                          ? this.state.classError
                          : "E.g Class 1 or Class 11 or Bachelor "
                      }
                      placeholder="Enter the name of className"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.className}
                      onChange={this.handleChange}
                    />

                    <TextField
                      name="faculty"
                      type="text"
                      label="Faculty"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      error={this.state.levelError ? true : false}
                      helperText={
                        this.state.facultyError
                          ? this.state.facultyError
                          : "E.g Science, Management, Bachelor in Hotel Management, etc"
                      }
                      placeholder="Enter the name of faculty"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.faculty}
                      onChange={this.handleChange}
                    />

                    <TextField
                      name="group"
                      type="text"
                      label="Group"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      helperText={
                        "E.g Physics Group, Biology Group, Business Group, etc"
                      }
                      placeholder="Enter the name of group"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.group}
                      onChange={this.handleChange}
                    />

                    <TextField
                      name="name"
                      type="text"
                      label="Section Name"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter the name of section"
                      error={this.state.sectionError ? true : false}
                      helperText={this.state.sectionError}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                        endAdornment: this.showAdd(),
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.sectionData.name}
                      onChange={this.handleSectionChange}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      type="submit"
                      aria-label="Submit"
                      variant="outlined"
                      className={classes.buttonStyle}
                    >
                      Submit
                    </Button>
                    {this.state.loading && <FormLoader />}
                  </div>
                </form>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
              <Paper className={classes.paper}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    name="name"
                    select
                    fullWidth
                    label="Subjects"
                    variant="outlined"
                    margin="normal"
                    error={this.state.subjectError ? true : false}
                    helperText={this.state.subjectError}
                    SelectProps={{ native: true }}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                        focused: classes.focused,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused,
                      },
                      shrink: true,
                    }}
                    value={this.state.subjectData.name}
                    onChange={this.handleSubjectChange}
                  >
                    <option value="">Select Any One</option>
                    {this.state.subData.map((subject, index) => (
                      <option key={index} value={subject.name}>
                        {subject.name}
                      </option>
                    ))}
                  </TextField>
                  <IconButton onClick={this.handleSubjectSubmit}>
                    <AddCircleIcon />
                  </IconButton>
                </div>
                <div style={{ textAlign: "center" }}>
                  <IconButton
                    onClick={() =>
                      this.props.history.push(`/administration/subject`)
                    }
                  >
                    <AddCircleIcon />
                  </IconButton>
                  If the subject you want to add is not listed please add the
                  subject manually
                </div>

                {this.state.data.subjects.length !== 0 &&
                  this.state.data.subjects.map((subject, index) => (
                    <Chip
                      key={index}
                      label={subject.name}
                      avatar={<Avatar>{subject.name.charAt(0)}</Avatar>}
                      onDelete={() => this.handleDeleteSubject(index)}
                      style={{ marginRight: 10 }}
                    />
                  ))}
              </Paper>
              <br />
              <Paper className={classes.paper}>
                <ViewSection
                  data={this.state.data}
                  sectionData={this.state.sectionData}
                  section={this.state.data.section}
                  handleSectionChange={this.handleSectionChange}
                  handleSectionSubmit={this.handleSectionSubmit}
                  handleDelete={this.handleDelete}
                  handleEdit={this.handleEdit}
                />
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddClass)));
